<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <!-- <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-file-invoice-dollar icon-primary mt-2"></i><h6 class="ms-2 mb-3">{{ $t('key_orderBack_summary') }}</h6>
      </div>
    </div>
    <div class="pb-0 card-body">
      <div class="d-flex justify-content-between">
        <span class="text-sm">{{ $t('key_orderBack_base_price') }}:</span>
        <span class="text-sm">{{ $numberFormat.toCurrency(orderBack.amount) }}</span>
      </div> 
      <div class="d-flex justify-content-between">
        <span class="text-sm">{{ $t('key_orderBack_tax_price') }}:</span>
        <span class="text-sm">{{ $numberFormat.toCurrency(orderBack.tax) }}</span>
      </div>
      <div class="d-flex justify-content-between mt-2">
        <span class="text-sm font-weight-bold">{{ $t('key_orderBack_total_price') }}:</span>
        <span class="text-sm  font-weight-bold">{{ $numberFormat.toCurrency(orderBack.total) }}</span>
      </div>
    </div> -->
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

  export default {
    name: "PurchaseSummary",
    components: {
    },
    props: {
      orderBack: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    }
  };

</script>

<style>

  .icon-primary {
    color: #4A7062 !important;
  }

</style>